import React from "react";

const swapna_khare = () => {
  return (
    <div>
      <h1>Swapna Khare</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        The initial criteria for shortlisting was 7.5 CGPA
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        The interview process had four stages: first was the aptitude test.
        After getting shortlisted for interviews, there were three rounds: first
        was an online technical round. Second was a project-discussion round and
        third was HR round
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The aptitude test had four sections.
        <br />
        Each section was different.
        <br />
        For the first section there was a DP problem which had to be solved in
        one hour.
        <br />
        After that there was an English section which had to be solved in 15
        minutes then there was a business interpretation section which also was
        to be sold in 15 minutes.
        <br />
        Then there were two coding questions.
        <br />
        The important part is that you could not navigate between the questions
        and sections, and you could only solve those questions in the allotted
        time.{" "}
      </p>

      <p>
        The most difficult section was the business interpretation. You can
        practice similar kinds of questions from Indiabix. There were also
        questions on candlestick graphs. The difficulty was quite high
        considering the limited amount of time that we had.
        <br />I was able to solve all the coding questions, both the DP and two
        coding questions at the end, which were quite simple.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        25 students were shortlisted after the aptitude test
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The results of the shortlist were announced on 12th September, and my
        interview was on 15th
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        There were three rounds.{" "}
      </p>

      <p>
        The <strong>first round</strong> was conducted online, but we were
        required to appear for it from the placement cell cabins. The
        interviewer primarily asked questions based on my résumé. I was first
        asked about my favourite subject, to which I answered Database
        Management Systems. Consequently, I was asked questions on DBMS
        fundamentals such as transactions, ACID properties, normalisation, and
        scaling.
      </p>

      <p>
        They also asked about my favourite data structure. I replied Linked
        List, so I was asked:
      </p>

      <ul>
        <li>How to merge two sorted linked lists </li>
        <li>How to find the middle node in a linked list </li>
        <li>Then keeping track of middle node using pointer</li>
      </ul>

      <p>
        For each of these, I first explained the brute-force approach and then
        walked them through the optimized solution. Explained the time and space
        complexity regardless of whether they asked or not.
      </p>

      <p>
        The key takeaway from this round is that you must thoroughly prepare
        from your résumé. The interviewer went through my entire résumé and
        asked questions based on the technologies, subjects, and even the
        extracurricular activities I had mentioned.
      </p>

      <p>
        This round was relatively easy for me, but it largely depends on the
        panel you get. Some of my peers were asked questions on multithreading,
        synchronization, and other advanced topics, so the difficulty level can
        vary significantly.
      </p>

      <p>Around 15 students were chosen from this round.</p>

      <p>
        All of us went to the HR round as well, there was no screening after the
        project discussion round.
      </p>

      <p>
        Then my <strong>second round</strong> was done in person in the TPO
        office.{" "}
      </p>

      <p>
        This round was more challenging and focused on assessing my
        problem-solving approach rather than just factual knowledge.
      </p>

      <p>
        The interviewer asked detailed questions about my projects, particularly
        focusing on why I made certain design choices. Some of the questions
        included:
      </p>

      <ul>
        <li>
          <p>
            Why did I use the Levenshtein algorithm for my spellchecker project?
          </p>
        </li>
        <li>
          <p>How would my project scale if used by many users?</p>
        </li>
        <li>
          <p>What features could I add to improve my existing project?</p>
        </li>
      </ul>

      <p>
        Since I had used JDBC in one of my projects, I was asked questions
        related to JDBC, then on JWT authentication for web development project,
        and then AES encryption. At one point, the interviewer mentioned that as
        the world moves towards quantum computing, AES encryption might become
        insecure - which prompted me to think critically and respond
        accordingly.{" "}
      </p>

      <p>
        I was asked to differentiate between AES and bcrypt, their use cases and
        why I had used them respectively.
      </p>

      <p>
        I was also asked practical questions, such as how to handle user input
        for date and time formats, where my initial approach was considered too
        straightforward. The interviewer expected me to think about input
        validation and error handling.
      </p>

      <p>
        Additionally, I was asked several SQL questions, especially about joins
        - left join, right join, and inner join. I was told to write several
        queries.
      </p>

      <p>
        Overall, this round was tough but insightful. The most important thing
        was to listen carefully to the hints the interviewer gave and adapt my
        responses. They were not necessarily looking for perfect answers but for
        candidates who could learn and think on their feet.
      </p>

      <p>
        I also learned that it’s essential to have a clear understanding of your
        projects’ limitations and to be able to explain how they could evolve.
        For example, when I described my password manager project, the
        interviewer asked how it could be applied in a banking scenario, which
        required me to think about its scalability and security aspects.
      </p>

      <p>
        The <strong>final round</strong> was a typical HR interview, lasting
        around 15 minutes. It felt like a rapid-fire session, where the
        interviewer continuously asked questions, one after another, without any
        long pauses.
      </p>

      <p>
        Since I had mentioned that I was leading a portfolio in my college’s
        fest, the interviewer asked me how I handle criticism while managing a
        team. They wanted to understand how I respond to feedback, especially
        when it comes from peers or seniors.
      </p>

      <p>
        Other questions revolved around my strengths and weaknesses, whether I
        see myself as a team player or an individual contributor, and why I
        enjoy taking leadership roles. How I handle stress, how I prioritise
        goals etc.
      </p>

      <p>
        The interviewer also asked a few questions about my family background to
        get to know me better.
      </p>

      <p>
        Towards the end, we discussed my extracurricular activities and how
        these contribute to my mental well-being.
      </p>

      <p>
        Overall, the HR round tested my presence of mind, clarity of thought,
        and ability to express myself confidently. The interviewer didn’t
        interrupt me mid-way, but always had a new question ready as soon as I
        finished answering - which kept the conversation dynamic and engaging.
      </p>

      <p>
        After each round, they ask you if you have any questions for them,which
        is a great opportunity for you to leave a good impression on them for
        every round. I had asked them different questions like how has your
        journey been in Wells Fargo? What do you think is the next thing in tech
        after AI, it can be on any topic that you might be interested in. They
        even asked me why I want to join Wells Fargo. So keep a good eye on the
        company PPT and make sure that you frame your answers based on the
        values that they mention they are looking for in a candidate and based
        on your own interests as well.
      </p>

      <p>In the end, out of 15, 10 students were selected.</p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
      </p>

      <p>
        I was asked very basic DSA questions. I was asked more about DBMS as I
        had mentioned it as my favourite subject. They also asked me questions
        based on core Java. I had mentioned computer networks in my resume, but
        I was not asked any questions based on it, and as for OS- I hadn’t
        mentioned it in my resume so again, no questions on it.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        I code in Java, so I did DSA using Kunal Kushwaha‘s playlist, Striver’s
        sheet and NeetCode 150. I had also used GFG last-minute notes to revise
        concepts.
        <br />
        Then I learnt DBMS using CodeHelp
        <br />
        Practiced aptitude questions, especially based on business
        interpretation and English using Indiabix.
        <br />
        And since my seniors were also asked questions on candlesticks last
        year, so I had practised those questions as well
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Think of the most brute force way and work towards optimising it.{" "}
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        Yes, I was asked a lot about these things.
        <br />
        My second round was fully based on my projects and how I can improve
        them and my understanding of them.
        <br />I was also asked about my clubs that I had mentioned on the resume
        and the extra-curriculars as well
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Practice candlestick graphs for the aptitude questions.
        <br />
        Practice plenty of typical questions on DP and on arrays and strings.
        <br />
        Have a good understanding of all the technologies that you mention in
        your resume.{" "}
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        A tip that I can give is to stay connected with your friends from other
        colleges.
        <br />
        For example, our interviews were after the interviews for Cummins
        College, so I had asked a friend of mine the type of questions she was
        asked.
        <br />
        She had cracked the Wells Fargo interview, so it definitely helps in
        mentally preparing you because each year the format changes, it was
        different for us and it was different for our seniors and it would be
        different for our juniors as well, so keep in touch with these people.
      </p>

      <p>
        Last thing - don’t lose hope, it took me two months since the internship
        process started, to secure an internship so I know how mentally draining
        it can be. Just focus on the things that you can control, prepare for
        all the points that you have mentioned in your resume and good things,
        better companies will always be waiting for you:)
      </p>

      <p>
        <strong>Contact Info</strong>
        <br />
        <strong>Email :</strong> <a href="mailto:kharesp23.comp@coeptech.ac.in">kharesp23.comp@coeptech.ac.in</a>
        <br />
        <strong>LinkedIn :</strong>{" "}
        <a href="https://www.linkedin.com/in/swapna-khare-349a112b8?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app">
          Swapna Khare
        </a>
      </p>
    </div>
  );
};

export default swapna_khare;
